import type { FunctionComponent, PropsWithChildren } from 'react';

import { GenericErrorConnected } from '../popup/content/GenericErrorContentConnected';

import { ErrorBoundary } from './ErrorBoundary';

export const LayoutErrorBoundaryConnected: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <ErrorBoundary fallback={<GenericErrorConnected inCurtain />} critical>
      {children}
    </ErrorBoundary>
  );
};
